import { TAPE } from './data';
// TAPE — full institutional book preview, large rows, hot/cold heat tinting.
export default function Tape() {
  return (
    <div className="bg-[#14110F] text-[#F8F4ED] min-h-screen">
      <section className="pt-32 pb-8 max-w-[1500px] mx-auto px-6 lg:px-10 border-b border-[#2A241F]">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#F59E0B] mb-3">— Live tape · 8 majors · UTC</p>
        <h1 className="font-serif italic text-[44px] lg:text-[88px] leading-[0.95]">The desk, in real time.</h1>
      </section>
      <section className="max-w-[1500px] mx-auto px-6 lg:px-10 py-10">
        <div className="border border-[#2A241F] bg-[#1A1612]">
          <div className="grid grid-cols-[140px_1fr_120px_120px_120px_100px] gap-4 px-5 py-3 border-b border-[#2A241F] font-mono text-[10px] tracking-[0.32em] uppercase text-[#F8F4ED]/55">
            <span>Symbol</span><span>Last</span><span>24h Δ</span><span>24h vol</span><span>OI</span><span></span>
          </div>
          <div className="divide-y divide-[#2A241F]">
            {TAPE.map((t) => (
              <div key={t.sym} data-testid={`aem-row-${t.sym.replace('/','-')}`} className="grid grid-cols-[140px_1fr_120px_120px_120px_100px] gap-4 px-5 py-4 items-center hover:bg-[#1F1A16] transition-colors">
                <span className="font-mono text-sm text-[#F59E0B]">{t.sym}</span>
                <span className="font-serif text-2xl tabular-nums">{t.last}</span>
                <span className={`font-mono text-sm ${t.state === 'up' ? 'text-[#34D399]' : 'text-[#F87171]'}`}>{t.ch}</span>
                <span className="font-mono text-sm text-[#F8F4ED]/65">{t.vol}</span>
                <span className="font-mono text-sm text-[#F8F4ED]/65">{(Math.random() * 50 + 5).toFixed(1)}B</span>
                <button className="font-mono text-[10px] tracking-[0.3em] uppercase border border-[#F59E0B]/40 text-[#F59E0B] px-3 py-1.5 hover:bg-[#F59E0B] hover:text-[#14110F] transition-colors">Trade →</button>
              </div>
            ))}
          </div>
        </div>
        <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#F8F4ED]/40 mt-6">— Quotes are indicative · OTC desk for blocks &gt; $250k · FIX 4.4 connectivity available</p>
      </section>
    </div>
  );
}
